import PdfPrinter from 'pdfmake/build/pdfmake.js'
import vfs_fonts from 'pdfmake/build/vfs_fonts.js';

export const openPDF = (docDefinition) => {
    var d = PdfPrinter.createPdf(docDefinition);
    d.vfs = vfs_fonts.pdfMake.vfs;
    d.open();
}

export const downloadPDF = (docDefinition, docName) => {
    var d = PdfPrinter.createPdf(docDefinition);
    d.vfs = vfs_fonts.pdfMake.vfs;
    d.download(docName);
}

export const asyncdownloadPDF = async(docDefinition, docName, pCallback, pUltInformeImpreso, pimprimiendoInforme) => {
    var d = PdfPrinter.createPdf(docDefinition);
    d.vfs = vfs_fonts.pdfMake.vfs;
    var a = d.download(docName, function(){a = docName; console.log("asyncdownloadPDF callback", a);pCallback(true);pUltInformeImpreso(pimprimiendoInforme);});
    console.log("asyncdownloadPDF", a);
    // alert(docName);
}